export const getBreadcrumbLabels = (state) => state.breadcrumbs.labels;

export const getBreadcrumbLabel = (state, path) => {
  return state.breadcrumbs.labels[path] || null;
};
